module.exports = __webpack_public_path__ + "static/media/traktoHG.1b45a1ec.svg";